import React, { useEffect, useMemo, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  TextField,
} from '@mui/material';
import { Norm } from '../RiskAssessment_ExcelImportHelpers';

/**
 * 마스터에 없는 부서명 — 부서 선택 다이얼로그 (부서 자동 생성 없음)
 */
function ExcelDeptSelectDialog({
  open,
  processNm = '',
  excelDepNm = '',
  depData = [],
  onConfirm,
  onCancel,
}) {
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!open) return;
    setSearch('');
    setSelected(null);
  }, [open, processNm]);

  const filtered = useMemo(() => {
    const q = Norm(search).toLowerCase();
    const list = Array.isArray(depData) ? depData : [];
    if (!q) return list;
    return list.filter((d) =>
      Norm(d?.label).toLowerCase().includes(q)
    );
  }, [depData, search]);

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 700 }}>부서 선택</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          공정 「{processNm}」을(를) 등록할 부서를 선택해 주세요.
          {excelDepNm ? (
            <>
              <br />
              엑셀 부서명 「{excelDepNm}」은(는) 등록된 부서와 일치하지
              않습니다.
            </>
          ) : (
            <>
              <br />
              엑셀에 부서명이 없어 부서를 지정해야 합니다.
            </>
          )}
        </Typography>
        <TextField
          size="small"
          fullWidth
          placeholder="부서 검색"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 1 }}
        />
        <List dense sx={{ maxHeight: 280, overflow: 'auto' }}>
          {filtered.map((d) => (
            <ListItemButton
              key={String(d?.value)}
              selected={selected?.value === d?.value}
              onClick={() => setSelected(d)}
            >
              <ListItemText primary={d?.label ?? ''} />
            </ListItemButton>
          ))}
          {filtered.length === 0 && (
            <Box sx={{ py: 2, textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary">
                검색 결과가 없습니다.
              </Typography>
            </Box>
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>취소</Button>
        <Button
          variant="contained"
          disabled={!selected}
          onClick={() => onConfirm?.(selected)}
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ExcelDeptSelectDialog;
